<template>
    <div>
        <v-dialog persistent v-model="display" :retain-focus="false">
            <v-card v-if="modulo!=null">
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>{{ modulo.nome }}: Dettagli Assembly</v-toolbar-title>
                        </v-col>
                        <v-col cols="2">
                            <v-btn small light @click="save">
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="close">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container>
                    <v-tabs v-model="tabs" centered>
                        <v-tab>Versioni libreria</v-tab>
                        <v-tab v-if="modulo.configurabile==1">Parametri modulo</v-tab>
                        <v-tab >Strumenti di diagnostica</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tabs">
                        <!-- Assembly -->
                        <v-tab-item>
                            <v-data-table :headers="platform_tab.headers" :items="cache_assembly" disable-pagination hide-default-footer class="mt-5">
                                <template v-slot:top>
                                    <v-toolbar dense color="primary" rounded>
                                        <v-row justify="center">
                                            <v-col cols="1">
                                                <v-btn small light @click="addAssembly">
                                                    <v-icon color="success">mdi-plus</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-toolbar>
                                </template>
                                <!-- Piattaforma -->
                                <template v-slot:[`item.tipo_piattaforma`]="{ item }">
                                    <v-select label="Piattaforma" v-model="item.tipo_piattaforma" item-value="id_piattaforma" item-text="nome" :items="platforms"/>
                                </template>
                                <!-- Upload libreria -->
                                <template v-slot:[`item._upload`]="{ item }">
                                    <v-btn small :disabled="item.validita!=1" @click="uploadBinary(item)">
                                        <v-icon color="primary">mdi-tray-arrow-up</v-icon>
                                    </v-btn>
                                </template>
                                <!-- Download libreria -->
                                <template v-slot:[`item._download`]="{ item }">
                                    <v-btn small :disabled="item.validita!=1||item.bin==null" @click="downloadBinary(item)">
                                        <v-icon color="primary">mdi-tray-arrow-down</v-icon>
                                    </v-btn>
                                </template>
                                <!-- Elimina -->
                                <template v-slot:[`item._delete`]="{ item }">
                                    <v-btn small @click="item.validita=item.validita==1?0:1">
                                        <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                        <!-- Config -->
                        <v-tab-item>
                            <v-expansion-panels accordion>
                                <v-expansion-panel v-for="(context,i) in config_tab.contexts" :key="i">
                                    <v-expansion-panel-header>{{config_tab.context_names[i]}}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-data-table :headers="config_tab.headers" :items="cache_config[context]" disable-pagination hide-default-footer class="mt-5" v-if="!(context=='part_program'&&modulo.output!=1)">
                                            <template v-slot:top>
                                                <v-toolbar dense color="primary" rounded>
                                                    <v-row justify="center">
                                                        <v-col cols="1">
                                                            <v-btn small light @click="addConfigField(context)">
                                                                <v-icon color="success">mdi-plus</v-icon>
                                                            </v-btn>
                                                        </v-col>
                                                    </v-row>
                                                </v-toolbar>
                                            </template>
                                            <!-- Nome -->
                                            <template v-slot:[`item.nome`]="{ item }">
                                                <v-text-field label="Nome" v-model="item.nome" />
                                            </template>
                                            <!-- Campo -->
                                            <template v-slot:[`item.campo`]="{ item }">
                                                <v-text-field label="Campo" v-model="item.campo" />
                                            </template>
                                            <!-- Tipo Input -->
                                            <template v-slot:[`item.tipo`]="{ item }">
                                                <v-select label="Tipo dato" v-model="item.tipo" item-value="id_tipo_input" item-text="nome" :items="input_types"/>
                                            </template>
                                            <!-- Valore default -->
                                            <template v-slot:[`item.valore_default`]="{ item }">
                                                <DynamicInput v-model="item.valore_default" :type="getInputType(item.tipo)" :items="getValues(item)" label="Valore default" item_text="testo" item_value="valore"/>
                                            </template>
                                            <!-- Valori -->
                                            <template v-slot:[`item._values`]="{ item }">
                                                <v-btn small :disabled="item.validita!=1||getInputType(item.tipo)!='enum'" @click="openValues(item)">
                                                    <v-icon color="primary">mdi-format-list-checkbox</v-icon>
                                                </v-btn>
                                            </template>
                                            <!-- Elimina -->
                                            <template v-slot:[`item._delete`]="{ item }">
                                                <v-btn small @click="item.validita=item.validita==1?0:1">
                                                    <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                        <v-card-text v-else>Il modulo "{{modulo.nome}}" non è marcato come output</v-card-text>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-tab-item>
                        <!-- Diagnostica -->
                        <v-tab-item>
                            <v-data-table :headers="diagnostic_tab.headers" :items="cache_config.diagnostic" disable-pagination hide-default-footer class="mt-5">
                                <template v-slot:top>
                                    <v-toolbar dense color="primary" rounded>
                                        <v-row justify="center">
                                            <v-col cols="1">
                                                <v-btn small light @click="addDiagnosticMethod">
                                                    <v-icon color="success">mdi-plus</v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-toolbar>
                                </template>
                                <!-- Nome -->
                                <template v-slot:[`item.nome`]="{ item }">
                                    <v-text-field label="Nome" v-model="item.nome" />
                                </template>
                                <!-- Id -->
                                <template v-slot:[`item.campo`]="{ item }">
                                    <v-text-field label="Id" v-model="item.campo" type="number" />
                                </template>
                                <!-- Elimina -->
                                <template v-slot:[`item._delete`]="{ item }">
                                    <v-btn small @click="item.validita=item.validita==1?0:1">
                                        <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-tab-item>
                    </v-tabs-items>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="values_dialog.display" :retain-focus="false">
            <v-card v-if="values_dialog.selected!=null">
                <v-toolbar dense color="primary" dark>
                    <v-row align="center" dark>
                        <v-col cols="5" align="left">
                            <v-toolbar-title>{{ values_dialog.selected.nome }}: Enumerazione</v-toolbar-title>
                        </v-col>
                        <v-col cols="1">
                            <v-btn small light @click="saveValues">
                                <v-icon color="success">mdi-floppy</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="1">
                             <v-btn small light @click="addValue">
                                <v-icon color="success">mdi-plus</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="closeValues">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container>
                    <v-data-table :headers="values_dialog.headers" :items="values_dialog.cloned" disable-pagination hide-default-footer class="mt-5">
                        <!-- Testo -->
                        <template v-slot:[`item.testo`]="{ item }">
                            <v-text-field label="Testo" v-model="item.testo"/>
                        </template>
                        <!-- Valore -->
                        <template v-slot:[`item.valore`]="{ item }">
                            <v-text-field label="Valore" v-model="item.valore" type="number"/>
                        </template>
                        <!-- Elimina -->
                        <template v-slot:[`item._delete`]="{ item }">
                            <v-btn small @click="item.validita=item.validita==1?0:1">
                                <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import DynamicInput from '../../.common/DynamicInput.vue';
export default {
    name:'GestioneAssembly',    
    props : {
        platforms : Array,
        input_types : Array
    },
    components : { DynamicInput },
    data(){
        return{
            cache_assembly:new Array(),
            cache_config:new Object(),
            config_tab : {
                context_names : ['Interfaccia','Registri','Variabili','Part Program'],
                contexts : ['interface','register','variable','part_program'],
                headers : [
                    { text:'Nome', value:'nome' },
                    { text:'Campo', value:'campo' },
                    { text:'Tipo dato', value:'tipo' },
                    { text:'Valore default', value:'valore_default' },
                    { text:'Valori', value:'_values' },
                    { text:'Elimina/Ripristina', value:'_delete' }
                ]
            },
            diagnostic_tab : {
                headers : [
                    { text:'Nome', value:'nome' },
                    { text:'Id', value:'campo' },
                    { text:'Elimina/Ripristina', value:'_delete' }
                ]
            },
            display:false,
            modulo:null,
            NETWORK : null,
            platform_tab : {
                headers : [
                    { text:'Piattaforma', value:'tipo_piattaforma' },
                    { text:'Upload Libreria', value:'_upload' },
                    { text:'Download Libreria', value:'_download' },
                    { text:'Elimina/Ripristina', value:'_delete' }
                ]
            },
            tabs:0,
            values_dialog : {
                cloned:null,
                display : false,
                headers : [
                    { text:'Testo', value:'testo' },
                    { text:'Valore', value:'valore' },
                    { text:'Elimina/Ripristina', value:'_delete' }
                ],
                selected : null
            }
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
    },
    methods:{
        addAssembly(){
            this.cache_assembly.push({
                id_assembly:-1,
                id_modulo:this.modulo.id_modulo,
                tipo_piattaforma:null,
                bin:null,
                validita:1
            });
        },
        addConfigField(context){
            this.cache_config[context].push({
                id_campo_configurazione:-1,
                riferimento:this.modulo.id_modulo,
                tipo:null,
                nome:null,
                campo:null,
                valore_default:null,
                contesto:context,
                valori:new Array(),
                validita:1
            });
        },
        addDiagnosticMethod(){
            this.cache_config.diagnostic.push({
                id_campo_configurazione:-1,
                riferimento:this.modulo.id_modulo,
                campo:null,
                contesto:'diagnostic',
                valori:new Array(),
                tipo:1,
                validita:1
            });
        },
        addValue(){
            this.values_dialog.cloned.push({
                id_valore:-1,
                riferimento:this.values_dialog.selected.id_campo_configurazione,
                valore:null,
                testo:null,
                validita:1
            });
        },
        close(){
            this.modulo = null;
            this.cache_assembly = null;
            this.cache_config = null;          
            this.display = false;
            this.tabs = 0;
        },
        closeValues(){
            this.values_dialog.selected = null;
            this.values_dialog.cloned = null;
            this.values_dialog.display = false;
        },
        downloadBinary(item){
            const binary = atob(item.bin); 
            const bytes = new Array(binary.length);
            for (let i = 0; i < binary.length; i++) {
                bytes[i] = binary.charCodeAt(i);
            }           
            const blob = new Blob([new Uint8Array(bytes)], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const download_link = document.createElement('a');

            let platform = 'Nessuna architettura';
            for(let i=0; i < this.platforms.length; i++){
                if(this.platforms[i].id_piattaforma == item.tipo_piattaforma){
                    platform = this.platforms[i].nome;
                    break;
                }
            }

            download_link.href = url;
            download_link.download = `${this.modulo.nome} - ${platform}.zip`;
            download_link.onclick = function(){
                setTimeout(function(){ URL.revokeObjectURL(url); }, 5000);               
            }
            download_link.click();
        },
        getInputType(id){
            for(let i=0; i<this.input_types.length;i++){
                if(this.input_types[i].id_tipo_input==id){ return this.input_types[i].valore; }
            }
            return null;
        },
        getValues(item){
            const result = new Array();
            for(let i=0; i<item.valori.length; i++){
                if(item.valori[i].validita==1){ result.push(item.valori[i]); }
            }
            return result;
        },
        open(module){
            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: 'getmoduleassemblies',
                        module_id : module.id_modulo,
                        token: localStorage.user_token,
                },
                method: 'POST',
                on: {
                    load: function (response) {
                        that.modulo = module;
                        that.cache_assembly = (JSON.parse(response));

                        const clone_config = JSON.parse(JSON.stringify(module.campi));
                        const cache_config = new Object();
                        for(let i=0; i<that.config_tab.contexts.length;i++){ cache_config[that.config_tab.contexts[i]] = new Array(); }
                        cache_config.diagnostic = new Array();

                        for(let i=0; i < clone_config.length; i++){
                            const config_item = clone_config[i];
                            if(cache_config[config_item.contesto]!=null){
                                cache_config[config_item.contesto].push(config_item);
                            }
                        }
                        that.cache_config = cache_config;
                        that.tabs = 0;
                        that.display = true;
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        openValues(item){
            this.values_dialog.selected = item;
            this.values_dialog.cloned = JSON.parse(JSON.stringify(item.valori));
            this.values_dialog.display = true;
        },
        save(){
            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: 'setmoduleassemblies',
                        assemblies : this.cache_assembly,
                        token: localStorage.user_token,
                },
                method: 'PUT',
                on: {
                    load: function () {
                        const config_result = new Array();
                        for(let i=0; i < that.config_tab.contexts.length;i++){
                            const context = that.config_tab.contexts[i];
                            for(let j=0; j < that.cache_config[context].length; j++){
                                config_result.push(that.cache_config[context][j]);
                            }
                        }
                        for(let i=0; i < that.cache_config.diagnostic.length; i++){
                            config_result.push(that.cache_config.diagnostic[i]);
                        }
                        that.modulo.campi = config_result;
                        that.close();
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        saveValues(){
            this.values_dialog.selected.valori = this.values_dialog.cloned;
            this.closeValues();
        },
        uploadBinary(item){
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", ".zip");
            input.onchange = function () {
                const reader = new FileReader();
                reader.onload = function () {
                    const result = reader.result;
                    const index = result.indexOf(';base64,') + 8;
                    const parsed_result = result.substring(index);
                    item.bin = parsed_result;
                    console.log(parsed_result);
                };
                reader.readAsDataURL(input.files[0]);
            };
            input.click();
        }
    }
}
</script>